import axios from '@/lib/AxApi';

export default {
    saveModule(params, cb)
    {
        axios.post('/Generator/saveModule', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
